import { createIcon } from '@chakra-ui/react';

export const External = createIcon({
  displayName: 'External',
  viewBox: '0 0 13.886 14',
  path: (
    <path
      id="External_Link_-_S-2"
      data-name="External Link - S"
      d="M12.417,7.19a.71.71,0,0,0-.7.71v5.144H1.914V3.211H7.1a.7.7,0,0,0,0-1.394H1.217a.7.7,0,0,0-.7.7V13.8a.7.7,0,0,0,.7.7h11.2a.7.7,0,0,0,.7-.7V7.9a.7.7,0,0,0-.7-.71ZM13.684.5H8.553a.71.71,0,0,0-.71.7.7.7,0,0,0,.71.7H12L5.271,8.621a.684.684,0,0,0,0,.988.671.671,0,0,0,.988,0l6.753-6.74v3.5a.7.7,0,1,0,1.394,0V1.2a.7.7,0,0,0-.7-.7Z"
      transform="translate(-0.52 -0.5)"
      fill="currentColor"
    />
  ),
});
